module.exports = __webpack_public_path__ + "static/media/list_download.bfb8ea20.svg";